import { MensajeProductoModel } from './MensajeProductoModel';

export class MensajeModel
{
	constructor() { }

	public IdMensaje: number = 0;
	public Nombre: string = "";
	public Telefono: string = "";
	public CorreoElectronico: string = "";
	public Mensaje: string = "";
	public newsLetter: boolean = false;
	public Captcha: string = "";

	public MensajesProductos: MensajeProductoModel[] = [];
}